import React, { useEffect, useState } from 'react';
import { CheckCircle, MapPin } from 'lucide-react';
const NAMES = ['María F.', 'Carlos M.', 'Ana G.', 'Juan P.', 'Sofía L.', 'Diego R.', 'Valentina S.', 'Mateo B.', 'Lucía T.', 'Santiago H.', 'Camila D.', 'Sebastián V.', 'Isabella C.', 'Alejandro M.', 'Gabriela P.', 'Florencia K.', 'Martín L.', 'Julieta R.', 'Nicolás B.', 'Agustina S.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'San Salvador de Jujuy', 'Corrientes'];
const PRODUCTS = ['Megapack Música Lista™', 'Megapack Música Lista™ + Bonos', 'Megapack Edición Docente'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    product: '',
    timeAgo: ''
  });
  useEffect(() => {
    // Initial delay - show quickly to establish social proof
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 3000);
    // More frequent notifications for urgency
    const interval = setInterval(() => {
      triggerNotification();
    }, Math.random() * (15000 - 8000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    const randomProduct = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
    const randomTime = Math.floor(Math.random() * 59) + 1;
    setData({
      name: randomName,
      city: randomCity,
      product: randomProduct,
      timeAgo: `${randomTime} min`
    });
    setVisible(true);
    // Hide after 6 seconds
    setTimeout(() => {
      setVisible(false);
    }, 6000);
  };
  if (!visible) return null;
  return <div className={`fixed bottom-4 left-4 md:left-auto md:right-4 z-50 max-w-[340px] w-full bg-white rounded-xl shadow-2xl border border-gray-100 p-4 transform transition-all duration-500 ease-in-out cursor-pointer hover:scale-105 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`} data-id="element-9">
      <div className="flex items-start gap-3" data-id="element-10">
        <div className="flex-shrink-0 relative" data-id="element-11">
          <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-12">
            <CheckCircle className="h-6 w-6 text-green-600" data-id="element-13" />
          </div>
          <span className="absolute -bottom-1 -right-1 flex h-4 w-4" data-id="element-14">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-15"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-green-500 border-2 border-white" data-id="element-16"></span>
          </span>
        </div>
        <div className="flex-1 min-w-0" data-id="element-17">
          <p className="text-sm font-bold text-gray-900 truncate" data-id="element-18">
            {data.name}
          </p>
          <p className="text-xs text-gray-500 flex items-center gap-1 mb-1" data-id="element-19">
            <MapPin className="w-3 h-3" data-id="element-20" /> {data.city}
          </p>
          <p className="text-xs text-gray-700" data-id="element-21">
            Compró{' '}
            <span className="font-semibold text-blue-600" data-id="element-22">{data.product}</span>
          </p>
          <p className="mt-1 text-[10px] text-gray-400 font-medium uppercase tracking-wide" data-id="element-23">
            Hace {data.timeAgo} • Verificado
          </p>
        </div>
      </div>
    </div>;
}